import type { ParamMap } from '@angular/router';

/**
 * OAuth query parameters used during authentication flows.
 * These params indicate an OAuth callback is in progress.
 *
 * Note: 'state' is intentionally NOT included here. The 'state' parameter alone
 * indicates where to redirect after login (set by is-authenticated.guard.ts),
 * not an OAuth callback. OAuth callbacks always include a 'code' parameter.
 * Including 'state' here causes the loading indicator to get stuck when
 * users navigate to the login page with only a state param.
 */
export const OAUTH_PARAMS = ['code', 'instant_login', 'scope'] as const;

/**
 * Check if query params contain OAuth callback parameters.
 * Used by both the login form and the redirect guard.
 */
export function hasOAuthParams(params: ParamMap): boolean {
	return OAUTH_PARAMS.some((param) => params.has(param));
}
